import * as THREE from "three";
import { const_var, params } from "../../../redux/reducers/reducer";
import { findActiveWall } from "../../building_pricing/wall_pricing/wallPricing.helper";
import { extractDataFromInner } from "../../../redux/reducers/utils";
import { extractDataFromInsulation } from "../../insulation_pricing/insulationPricing.helper";
import { controls } from "../../../redux/reducers/common/eventReducer";
import * as cuComponent from "../../../redux//reducers/building_component/componentReducer";

export const makeTranslucent = (isCheckActiveTab, wallName, is_translusant, scene, isStorageDragging, storageSection) => {
	if (scene == "") {
		return;
	}

	if (isStorageDragging !== undefined && storageSection !== undefined) {
		const visibleGroup = scene.getObjectByName(storageSection);

		scene.traverseVisible((mesh) => {
			if (mesh.isMesh && !["Ground-Surface", "background", "manufacturerLogoFront", "manufacturerLogoBack", "manufacturerLogoCenter", "cupola"].some((name) => mesh.name.includes(name))) {
				if (isStorageDragging) {
					mesh.material.opacity = 0.02;
					if (mesh.name.includes("measurement_value")) {
						mesh.visible = false;
					} else {
						mesh.material.transparent = true;
						if (mesh.parent.name.includes("DoorWindows")) mesh.parent.isTransparent = true;
					}
					mesh.material.transparent = true;
				} else {
					if (mesh.parent.name.includes("measurement_value_group")) {
						mesh.parent.children.forEach((item) => {
							if (item.name.includes("measurement_value")) item.visible = true;
							else mesh.material.opacity = 1;
						});
					} else {
						mesh.material.transparent = false;
						mesh.material.depthWrite = true;
						if (mesh.parent.name.includes("DoorWindows")) mesh.parent.isTransparent = false;
					}
				}
				mesh.material.needsUpdate = true;
			}
		});

		// Ensure visibleGroup's meshes are rendered without transparency.
		visibleGroup?.traverseVisible((mesh) => {
			if (mesh.isMesh) {
				mesh.material.transparent = false;
				mesh.material.depthWrite = true;
				mesh.material.needsUpdate = true;
				if (mesh.parent.name.includes("DoorWindows")) mesh.parent.isTransparent = false;
			}
		});
	} else {
		let section = cuComponent.wallnameBySec[wallName];

		let visibleGroup = scene.getObjectByName(section);
		let legGroup = scene.getObjectByName("legGroup");
		let centerMeaurement = scene.getObjectByName("Measurements-main");
		let leftMeaurement = scene.getObjectByName("Measurements-leftLeanto");
		let rightMeaurement = scene.getObjectByName("Measurements-rightLeanto");
		let frontMeaurement = scene.getObjectByName("Measurements-frontLeanto");
		let backMeaurement = scene.getObjectByName("Measurements-backLeanto");
		let doorMeaurement = scene.getObjectByName("Measurements-door");
		let windowMeaurement = scene.getObjectByName("Measurements-window");
		if (visibleGroup == undefined) return;

		if (legGroup != undefined) legGroup.visible = false;

		if (is_translusant == false && isCheckActiveTab == "doorwindow") visibleGroup.visible = false;

		if (isCheckActiveTab != "doorwindow") findActiveWall("canvas", const_var.controls, const_var.wallSelection.centerBuildingWall, controls.isCheckActiveTab);

		if (scene != undefined && scene != "") {
			scene.traverseVisible((mesh) => {
				if (
					mesh.isMesh &&
					!mesh.name.includes("Ground-Surface") &&
					!mesh.name.includes("background") &&
					mesh.name != "manufacturerLogoFront" &&
					mesh.name != "manufacturerLogoBack" &&
					mesh.name != "manufacturerLogoCenter" &&
					!mesh.name.includes("cupola")
				) {
					mesh.material.opacity = 0.02;

					if (
						isCheckActiveTab == "doorwindow" ||
						(is_translusant == true &&
							!mesh.parent.name.includes("legs") &&
							!mesh.parent.name.includes("DoorWindows") &&
							!mesh.name.includes("glass") &&
							!mesh.name.includes("shape") &&
							!mesh.name.includes("pattern") &&
							!mesh?.name?.includes("backStorage"))
					) {
						if (mesh.name.includes("measurement_value")) {
							mesh.visible = false;
						} else {
							mesh.material.transparent = true;
							if (mesh.parent.name.includes("DoorWindows")) mesh.parent.isTransparent = true;
						}
					} else {
						if (mesh.parent.name.includes("measurement_value_group")) {
							mesh.parent.children.forEach((item) => {
								if (item.name.includes("measurement_value")) item.visible = true;
								else mesh.material.opacity = 1;
							});
						} else {
							mesh.material.transparent = false;
							mesh.material.depthWrite = true;
							if (mesh.parent.name.includes("DoorWindows")) mesh.parent.isTransparent = false;
						}
					}
					mesh.material.needsUpdate = true;
				}
			});
		}

		if (visibleGroup.visible == false) {
			let doorWindowsArr = [];
			visibleGroup.traverse((mesh) => {
				if (mesh.isMesh && mesh.name != "manufacturerLogoFront" && mesh.name != "manufacturerLogoBack" && mesh.name != "manufacturerLogoCenter" && !mesh.name.includes("cupola")) {
					if (
						(wallName == "c_b_r_s_l_w" && (mesh.name.includes("left_leg") || mesh.name.includes("left-leg-slope-rail") || mesh.name.includes("c_b_l_w") || mesh.parent.name.includes("c_b_l_w"))) ||
						(wallName == "c_b_l_s_r_w" && (mesh.name.includes("right_leg") || mesh.name.includes("right-leg-slope-rail") || mesh.name.includes("c_b_r_w") || mesh.parent.name.includes("c_b_r_w"))) ||
						(wallName == "c_b_f_s_w" && (mesh.name.includes("front_leg") || mesh.name.includes("c_b_f_w") || mesh.parent.name.includes("c_b_f_w"))) ||
						(wallName == "c_b_b_s_w" && (mesh.name.includes("back_leg") || mesh.name.includes("c_b_b_w") || mesh.parent.name.includes("c_b_b_w"))) ||
						(wallName == "L_L_F_S_W" && (mesh.name.includes("lean_front_leg") || mesh.name.includes("lean_leg") || mesh.name.includes("L_L_F_W") || mesh.parent.name.includes("L_L_F_W"))) ||
						mesh.name.includes("left-lean-front-trim") ||
						(wallName == "L_L_B_S_W" && (mesh.name.includes("lean_back_leg") || mesh.name.includes("lean_leg") || mesh.name.includes("L_L_B_W") || mesh.parent.name.includes("L_L_B_W"))) ||
						mesh.name.includes("left-lean-back-trim") ||
						(wallName == "R_L_F_S_W" && (mesh.name.includes("lean_front_leg") || mesh.name.includes("lean_leg") || mesh.name.includes("R_L_F_W") || mesh.parent.name.includes("R_L_F_W"))) ||
						mesh.name.includes("right-lean-front-trim") ||
						(wallName == "R_L_B_S_W" && (mesh.name.includes("lean_back_leg") || mesh.name.includes("lean_leg") || mesh.name.includes("R_L_B_W") || mesh.parent.name.includes("R_L_B_W"))) ||
						mesh.name.includes("right-lean-back-trim") ||
						(wallName == "F_L_R_S_W" && (mesh.name.includes("lean_front_leg") || mesh.name.includes("lean_leg") || mesh.name.includes("F_L_R_W") || mesh.parent.name.includes("F_L_R_W"))) ||
						(wallName == "F_L_L_S_W" && (mesh.name.includes("lean_back_leg") || mesh.name.includes("lean_leg") || mesh.name.includes("F_L_L_W") || mesh.parent.name.includes("F_L_L_W"))) ||
						(wallName == "B_L_L_S_W" && (mesh.name.includes("lean_front_leg") || mesh.name.includes("lean_leg") || mesh.name.includes("B_L_F_W") || mesh.parent.name.includes("B_L_F_W"))) ||
						mesh.name.includes("front-inner-pillar-model") ||
						(wallName == "B_L_R_S_W" && (mesh.name.includes("lean_back_leg") || mesh.name.includes("lean_leg") || mesh.name.includes("B_L_B_W") || mesh.parent.name.includes("B_L_B_W"))) ||
						(wallName == "G_L_L_F_S_W" && (mesh.name.includes("gable_left_lean_front_leg") || mesh.name.includes("G_L_L_F_W") || mesh.parent.name.includes("G_L_L_F_W"))) ||
						(wallName == "G_L_L_B_S_W" && (mesh.name.includes("gable_left_lean_back_leg") || mesh.name.includes("G_L_L_B_W") || mesh.parent.name.includes("G_L_L_B_W"))) ||
						(wallName == "G_R_L_F_S_W" && (mesh.name.includes("gable_right_lean_front_leg") || mesh.name.includes("G_R_L_F_W") || mesh.parent.name.includes("G_R_L_F_W"))) ||
						(wallName == "G_R_L_B_S_W" && (mesh.name.includes("gable_right_lean_back_leg") || mesh.name.includes("G_R_L_B_W") || mesh.parent.name.includes("G_R_L_B_W"))) ||
						(wallName == "G_F_L_F_S_W" && (mesh.name.includes("gable_front_lean_front_leg") || mesh.name.includes("G_F_L_F_W") || mesh.parent.name.includes("G_F_L_F_W"))) ||
						(wallName == "G_F_L_B_S_W" && (mesh.name.includes("gable_front_lean_back_leg") || mesh.name.includes("G_F_L_B_W") || mesh.parent.name.includes("G_F_L_B_W"))) ||
						(wallName == "G_B_L_F_S_W" && (mesh.name.includes("gable_back_lean_front_leg") || mesh.name.includes("G_B_L_F_W") || mesh.parent.name.includes("G_B_L_F_W"))) ||
						(wallName == "G_B_L_B_S_W" && (mesh.name.includes("gable_back_lean_back_leg") || mesh.name.includes("G_B_L_B_W") || mesh.parent.name.includes("G_B_L_B_W")))
					) {
						mesh.material.opacity = 0.02;
						mesh.material.transparent = true;
						if (mesh.parent.name.includes("DoorWindows")) {
							mesh.parent.isTransparent = true;
							if (!doorWindowsArr.includes(mesh.parent.name)) doorWindowsArr.push(mesh.parent.name);
						}
					} else {
						if (mesh.parent.name.includes("measurement_value_group")) {
							mesh.parent.children.forEach((item) => {
								if (item.name.includes("measurement_value")) item.visible = true;
								else mesh.material.opacity = 1;
							});
						} else {
							mesh.material.transparent = false;
							mesh.material.depthWrite = true;
						}
						if (mesh.parent.name.includes("DoorWindows")) {
							mesh.parent.isTransparent = false;
							if (!doorWindowsArr.includes(mesh.parent.name + "false")) doorWindowsArr.push(mesh.parent.name + "false");
						}
					}
					mesh.material.needsUpdate = true;
				}
			});

			if (doorWindowsArr.length > 0) {
				doorWindowsArr.map((componentName) => {
					let component = scene.getObjectByName(componentName);
					if (component != undefined) {
						if (!componentName.includes("false")) {
							component.traverse((componentChild) => {
								if (componentChild.isMesh) {
									componentChild.material.opacity = 0.02;
									componentChild.material.transparent = true;
									componentChild.material.needsUpdate = true;
								}
							});
						} else {
							component.traverse((componentChild) => {
								if (componentChild.isMesh) {
									componentChild.material.transparent = false;
									componentChild.material.needsUpdate = true;
								}
							});
						}
					}
				});
			}
		}

		visibleGroup.visible = true;
		if (legGroup != undefined) legGroup.visible = true;

		visibleGroup.needsUpdate = true;
		if (legGroup != undefined) legGroup.needsUpdate = true;
	}
};

export const findMaxLimitY = (buildingType, wallName, height, width, componentDistance, positionX, limitYmax) => {
	let sectionHeight = params.p_h;
	let sectionWidth = params.p_w;
	let sectionPitch = params.p_r_p;
	let regularHeight = 0;
	let isEndSide = false;
	let leanPositionSign =
		wallName === "G_R_L_B_W" ||
		wallName === "G_R_L_B_S_W" ||
		wallName === "G_L_L_F_W" ||
		wallName === "G_L_L_F_S_W" ||
		wallName === "G_F_L_F_W" ||
		wallName === "G_F_L_F_S_W" ||
		wallName === "G_B_L_B_W" ||
		wallName === "G_B_L_B_S_W"
			? -1
			: 1;
	if (params.p_r_s == 1) regularHeight = const_var.roofRegularDst * 2;

	if (buildingType == "leftlean") {
		sectionHeight = params.lean_p_h;
		sectionWidth = (params.lean_p_w + params.p_w / 2) * 2;
		sectionPitch = params.b_l_t_r_p;
	} else if (buildingType == "gableLeftLean") {
		sectionHeight = params.lean_p_h;
		sectionWidth = params.lean_p_w;
		sectionPitch = params.b_l_t_r_p;
		positionX = positionX + params.lean_p_pos * leanPositionSign;
	} else if (buildingType == "rightlean") {
		sectionHeight = params.leanR_p_h;
		sectionWidth = (params.leanR_p_w + params.p_w / 2) * 2;
		sectionPitch = params.b_l_t_r_pR;
	} else if (buildingType == "gableRightLean") {
		sectionHeight = params.leanR_p_h;
		sectionWidth = params.leanR_p_w;
		sectionPitch = params.b_l_t_r_pR;
		positionX = positionX + params.leanR_p_pos * leanPositionSign;
	} else if (buildingType == "frontlean") {
		sectionHeight = params.leanF_p_h;
		sectionWidth = (params.leanF_p_w + params.p_d / 2) * 2;
		sectionPitch = params.b_l_t_r_pF;
	} else if (buildingType == "gableFrontLean") {
		sectionHeight = params.leanF_p_h;
		sectionWidth = params.leanF_p_w;
		sectionPitch = params.b_l_t_r_pF;
		positionX = positionX + params.leanF_p_pos * leanPositionSign;
	} else if (buildingType == "backlean") {
		sectionHeight = params.leanB_p_h;
		sectionWidth = (params.leanB_p_w + params.p_d / 2) * 2;
		sectionPitch = params.b_l_t_r_pB;
	} else if (buildingType == "gableBackLean") {
		sectionHeight = params.leanB_p_h;
		sectionWidth = params.leanB_p_w;
		sectionPitch = params.b_l_t_r_pB;
		positionX = positionX + params.leanB_p_pos * leanPositionSign;
	}

	let sign = Math.sign(positionX);
	if (params.singleSlope && buildingType == "center") sign = -1;
	let posX = (sectionPitch / 12) * positionX * sign;
	let widthVal = (sectionPitch / 12) * (sectionWidth / 2);
	if (params.singleSlope && buildingType == "center") widthVal = -widthVal;
	let maxLimit = sectionHeight + widthVal - posX - height / 2 - componentDistance - (sectionPitch / 12) * (width / 2);

	if (const_var.entry_wall_location[wallName] != undefined && const_var.entry_wall_location[wallName].includes("end") && wallName != "c_b_l_s_r_w" && wallName != "c_b_r_s_l_w") {
		maxLimit = sectionHeight + widthVal - posX - height / 2 - componentDistance - (sectionPitch / 12) * (width / 2) + regularHeight;
		isEndSide = true;
	} else {
		maxLimit = limitYmax;
	}

	return { maxLimit: maxLimit, sectionHeight: sectionHeight, sectionWidth: sectionWidth, sectionPitch: sectionPitch, isEndSide: isEndSide };
};
export const manageOverheadDoorObject = (response) => {
	if (response.data.data.pricing_data.garage_door_v3 != undefined && response.data.data.pricing_data.garage_door_v3.overhead_door_door != undefined) {
		let overhead = response.data.data.pricing_data.garage_door_v3.overhead_door_door.find((e) => e.name == "Overhead");
		if (overhead) {
			overhead.data.forEach((e) => {
				if (e.door_add_ons) {
					let windowOptions = e.door_add_ons.find((i) => i.door == "window_option");
					if (windowOptions) {
						windowOptions.category = windowOptions.category.map((item) => {
							if (typeof item == "string") {
								return {
									category: item,
									cost: windowOptions.cost,
									cost_type: windowOptions.cost_type,
									is_cost: windowOptions.is_cost
								};
							} else {
								return item;
							}
						});

						delete windowOptions.cost;
						delete windowOptions.cost_type;
						delete windowOptions.is_cost;
					}

					let motorOptions = e.door_add_ons.find((i) => i.door == "motor");
					if (motorOptions) {
						motorOptions.category = motorOptions.category.map((item, index) => {
							if (typeof item == "string") {
								return {
									category: item,
									cost: motorOptions.cost.split(",")[index],
									cost_type: motorOptions.cost_type,
									is_cost: motorOptions.is_cost
								};
							} else {
								return item;
							}
						});

						delete motorOptions.cost;
						delete motorOptions.cost_type;
						delete motorOptions.is_cost;
					}

					let insulatedOptions = e.door_add_ons.find((i) => i.door == "insulated");
					if (insulatedOptions) {
						insulatedOptions.category = insulatedOptions.category.map((item) => {
							if (typeof item == "string") {
								return {
									category: item,
									cost: insulatedOptions.cost,
									cost_type: insulatedOptions.cost_type,
									is_cost: insulatedOptions.is_cost
								};
							} else {
								return item;
							}
						});

						delete insulatedOptions.cost;
						delete insulatedOptions.cost_type;
						delete insulatedOptions.is_cost;
					}
					let isAddOnOptionsOld = false;
					let addOnOptions = e.door_add_ons.filter((i) => i.door == "add_on_options");
					addOnOptions.map((addOnOption) => {
						addOnOption.category = addOnOption.category.map((item) => {
							if (typeof item == "string") {
								isAddOnOptionsOld = true;
								return {
									category: item,
									cost: addOnOption.cost,
									cost_type: addOnOption.cost_type,
									is_cost: addOnOption.is_cost
								};
							} else {
								return item;
							}
						});

						delete addOnOption.cost;
						delete addOnOption.cost_type;
						delete addOnOption.is_cost;
					});

					if (isAddOnOptionsOld) {
						e.door_add_ons = e.door_add_ons.filter((i) => i.door != "add_on_options");
						e.door_add_ons.push({ door: "add_on_options", category: addOnOptions.map((e) => e.category[0]) });
					}
				}
			});
		}
	}

	if (response.data.data.request_data.building != undefined && response.data.data.request_data.building.entry_points != undefined) {
		response.data.data.request_data.building.entry_points.forEach((item) => {
			let e = item.entry_size;
			if (e.door_add_ons) {
				let windowOptions = e.door_add_ons.find((i) => i.door == "window_option");
				if (windowOptions) {
					windowOptions.category = windowOptions.category.map((item) => {
						if (typeof item == "string") {
							const_var.isShowAlert = true;
							const_var.alertUsedFor = "showOverheadOldQuoteOrderMsg";
							return {
								category: item,
								cost: windowOptions.cost,
								cost_type: windowOptions.cost_type,
								is_cost: windowOptions.is_cost
							};
						} else {
							return item;
						}
					});

					delete windowOptions.cost;
					delete windowOptions.cost_type;
					delete windowOptions.is_cost;
				}

				let motorOptions = e.door_add_ons.find((i) => i.door == "motor");
				if (motorOptions) {
					motorOptions.category = motorOptions.category.map((item, index) => {
						if (typeof item == "string") {
							const_var.isShowAlert = true;
							const_var.alertUsedFor = "showOverheadOldQuoteOrderMsg";
							return {
								category: item,
								cost: motorOptions.cost.split(",")[index],
								cost_type: motorOptions.cost_type,
								is_cost: motorOptions.is_cost
							};
						} else {
							return item;
						}
					});

					delete motorOptions.cost;
					delete motorOptions.cost_type;
					delete motorOptions.is_cost;
				}

				let insulatedOptions = e.door_add_ons.find((i) => i.door == "insulated");
				if (insulatedOptions) {
					insulatedOptions.category = insulatedOptions.category.map((item) => {
						if (typeof item == "string") {
							const_var.isShowAlert = true;
							const_var.alertUsedFor = "showOverheadOldQuoteOrderMsg";
							return {
								category: item,
								cost: insulatedOptions.cost,
								cost_type: insulatedOptions.cost_type,
								is_cost: insulatedOptions.is_cost
							};
						} else {
							return item;
						}
					});

					delete insulatedOptions.cost;
					delete insulatedOptions.cost_type;
					delete insulatedOptions.is_cost;
				}
				let isAddOnOptionsOld = false;
				let addOnOptions = e.door_add_ons.filter((i) => i.door == "add_on_options");
				addOnOptions.map((addOnOption) => {
					addOnOption.category = addOnOption.category.map((item) => {
						if (typeof item == "string") {
							const_var.isShowAlert = true;
							const_var.alertUsedFor = "showOverheadOldQuoteOrderMsg";
							isAddOnOptionsOld = true;
							return {
								category: item,
								cost: addOnOption.cost,
								cost_type: addOnOption.cost_type,
								is_cost: addOnOption.is_cost
							};
						} else {
							return item;
						}
					});

					delete addOnOption.cost;
					delete addOnOption.cost_type;
					delete addOnOption.is_cost;
				});

				if (isAddOnOptionsOld) {
					e.door_add_ons = e.door_add_ons.filter((i) => i.door != "add_on_options");
					e.door_add_ons.push({ door: "add_on_options", category: addOnOptions.map((e) => e.category[0]) });
				}
			}
		});
	}
};
export const prepareObjToShowValue = () => {
	const uniqueComponentObjects = const_var.thirdPartyComponent.commissions.garage ? extractDataFromInner(const_var.thirdPartyComponent.commissions.garage) : [];
	const uniqueComponentObjectsSurcharge = const_var.thirdPartyComponent.surcharge.garage ? extractDataFromInner(const_var.thirdPartyComponent.surcharge.garage) : [];
	const uniqueInsulationObjects = const_var.thirdPartyComponent?.commissions?.insulation ? extractDataFromInsulation(const_var.thirdPartyComponent.commissions.insulation) : [];
	const uniqueInsulationObjectsSurcharge = const_var.thirdPartyComponent?.surcharge?.insulation ? extractDataFromInsulation(const_var.thirdPartyComponent.surcharge.insulation) : [];
	const_var.thirdPartyPricesObj.garage = {};
	const_var.thirdPartyPricesObj.insulation = {};

	if (uniqueComponentObjects?.length > 0) {
		let garage_commission_amount = parseFloat(const_var.thirdPartyComponent.commissions.garage.totalPrice) || 0;
		let garage_total_val = parseFloat(const_var.thirdPartyComponent.commissions.garage.allDoorPrices) || 0;
		let garage_tax_val = parseFloat(const_var.thirdPartyComponent.commissions.garage.taxValue) || 0;
		let garage_add_val = parseFloat(const_var.thirdPartyComponent.surcharge.garage.additionalValue) || 0;
		let garage_surcharge_val = parseFloat(const_var.thirdPartyComponent.surcharge.garage.taxValue) || 0;
		let garage_subtotal = parseFloat(garage_total_val) + parseFloat(garage_surcharge_val);
		let garage_due_amount = parseFloat(garage_subtotal) + parseFloat(garage_tax_val) - parseFloat(garage_commission_amount) + parseFloat(garage_add_val);

		const_var.thirdPartyPricesObj.garage["garage_commission_amount"] = garage_commission_amount;
		const_var.thirdPartyPricesObj.garage["garage_total_val"] = garage_total_val;
		const_var.thirdPartyPricesObj.garage["garage_surcharge_val"] = garage_surcharge_val;
		const_var.thirdPartyPricesObj.garage["garage_subtotal"] = garage_subtotal;
		const_var.thirdPartyPricesObj.garage["garage_due_amount"] = garage_due_amount;
		const_var.thirdPartyPricesObj.garage["garage_tax_val"] = garage_tax_val;
		const_var.thirdPartyPricesObj.garage["garage_add_val"] = garage_add_val;
	}
	if (uniqueInsulationObjects?.length > 0) {
		let inc_commission_amount = parseFloat(const_var.thirdPartyComponent.commissions.insulation.totalPrice) || 0;
		let inc_total_val = parseFloat(const_var.thirdPartyComponent.commissions.insulation.incTotalValue) || 0;
		let inc_surcharge_val = parseFloat(const_var.thirdPartyComponent.surcharge.insulation.taxValue) || 0;
		let inc_add_val = parseFloat(const_var.thirdPartyComponent.surcharge.insulation.additionalValue) || 0;
		let inc_tax_val = parseFloat(const_var.thirdPartyComponent.commissions.insulation.taxValue) || 0;
		let inc_subtotal = parseFloat(inc_total_val) + parseFloat(inc_surcharge_val) || 0;
		let inc_due_amount = parseFloat(parseFloat(inc_subtotal) + parseFloat(inc_tax_val)) - parseFloat(inc_commission_amount) + parseFloat(inc_add_val);

		const_var.thirdPartyPricesObj.insulation["inc_commission_amount"] = inc_commission_amount;
		const_var.thirdPartyPricesObj.insulation["inc_total_val"] = inc_total_val;
		const_var.thirdPartyPricesObj.insulation["inc_surcharge_val"] = inc_surcharge_val;
		const_var.thirdPartyPricesObj.insulation["inc_subtotal"] = inc_subtotal;
		const_var.thirdPartyPricesObj.insulation["inc_due_amount"] = inc_due_amount;
		const_var.thirdPartyPricesObj.insulation["inc_tax_val"] = inc_tax_val;
		const_var.thirdPartyPricesObj.insulation["inc_add_val"] = inc_add_val;
	}
	return const_var.thirdPartyComponent;
};
